import React from "react";
import './LoginConnecting.css';

function LoginConnecting({ connecting, connected, register }) {

    const getStatusMessage = () => {
        if (connecting && !connected) return "Connecting to server...";
        if (connected && !register) return "Logging into your account...";
        if (connected && register) return "Creating your account...";
        return "Please wait...";
    };

    const getStatusIcon = () => {
        if (connecting && !connected) return "wifi";
        if (connected && !register) return "login";
        if (connected && register) return "person_add";
        return "hourglass_empty";
    };

    return (
        <div className="connecting-container">
            <div className="connecting-content">
                <div className="connecting-header">
                    <span className="material-symbols-outlined connecting-icon">
                        {getStatusIcon()}
                    </span>
                    <h1>Please Wait</h1>
                </div>
                
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <p className="status-message">{getStatusMessage()}</p>
                </div>
                
                <div className="connecting-footer">
                    <p>This should only take a moment...</p>
                </div>
            </div>
        </div>
    );
}

export default LoginConnecting;